/* eslint-disable no-sparse-arrays */
// component
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

let navConfig = {};

navConfig["0"] = [
  {
    title: "dashboard",
    path: "/dashboard/app",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "User Vendor",
    path: "/dashboard/uservendor/list",
    icon: getIcon("eva:people-fill"),
  },
  {
    title: "Check Api",
    path: "/dashboard/check-api",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "Balance Check & Join Game Api",
        path: "/dashboard/check-api/balance-check-api",
      },
      // {
      //   title: "Join Game Api",
      //   path: "/dashboard/check-api/join-game-api",
      // },
      {
        title: "Deposit balance Api",
        path: "/dashboard/check-api/deposit",
      },
    ],
  },
  {
    title: "Cron Activity",
    path: "/dashboard",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Cricket Match",
        path: "/dashboard/cricket_matches",
      },
      {
        title: "Football Match",
        path: "/dashboard/football_matches",
      }]
    },
  {
    title: "Points Management",
    path: "/dashboard/points-management",
    icon: getIcon("ph:coin-vertical-fill"),
    children: [
      {
        title: "Cricket Points",
        path: "/dashboard/points-management/cricket",
      },
      {
        title: "Football Points",
        path: "/dashboard/points-management/football",
      },
    ],
  },
  {
    title: "State Management",
    path: "/dashboard/state-management",
    icon: getIcon("mdi:flag"),
  },
  {
    title: "Reports",
    path: "/dashboard/report_management",
    icon: getIcon("mdi:cog"),
    children: [
      {
        title: "Cricket Status",
        path: "/dashboard/status-management/cricket",
        icon: getIcon("mdi:cog"),
      },
      {
        title: "Football Status",
        path: "/dashboard/status-management/football",
        icon: getIcon("mdi:cog"),
      },

      {
        title: "Transaction History",
        path: "/dashboard/transactions",
        icon: getIcon("ph:currency-circle-dollar-fill"),
      },
      {
        title: "Report Management",
        path: "/dashboard/report_management",
        icon: getIcon("mdi:cog"),
      },
    ],
  },

  {
    title: "Settings",
    path: "/dashboard/settings",
    icon: getIcon("mdi:cog"),
  },
];

navConfig["2"] = [
  {
    title: "dashboard",
    path: "/dashboard/app",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "User Management",
    path: "/dashboard/user",
    icon: getIcon("eva:people-fill"),
    children: [
      // {
      //     title: "List",
      //     path: "/dashboard/user/list",
      // },

      {
        title: "Active User",
        path: "/dashboard/user/list?type=1",
      }
    ],
  },
  {
    title: "Cricket Matches",
    path: "/dashboard/cricket",
    icon: getIcon("material-symbols:sports-cricket"),
    children: [
      {
        title: "Upcoming Matches",
        path: "/dashboard/cricket/upcoming_match_list",
      },
      {
        title: "Active Matchs",
        path: "/dashboard/cricket/active_match_list",
      },
      {
        title: "Contests",
        path: "/dashboard/cricket/contest_list",
      },
      // {
      //   title: 'Assign Contest',
      //   path: '/dashboard/cricket/assign_contest_list'
      // },
    ],
  },
  {
    title: "Football Matches",
    path: "/dashboard/football",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Upcoming Matches",
        path: "/dashboard/football/upcoming_football_list",
      },
      {
        title: "Active Matchs",
        path: "/dashboard/football/active_football_list",
      },
      {
        title: "Contests",
        path: "/dashboard/football/contest_football_list",
      },
      // {
      //   title: 'Assign Contest',
      //   path: '/dashboard/cricket/assign_contest_list'
      // },
    ],
  },
  {
    title: "Cricket Series",
    path: "/dashboard/series/cricket",
    icon: getIcon("material-symbols:sports-cricket"),
    children: [
      {
        title: "Upcoming Series",
        path: "/dashboard/series/cricket/upcomingseries",
      },
      {
        title: "Active Series",
        path: "/dashboard/series/cricket/activeseries",
      },
      {
        title: "Contests",
        path: "/dashboard/series/cricket/contest",
      },
    ],
  },
  {
    title: "Football Series",
    path: "/dashboard/series/football",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Upcoming Series",
        path: "/dashboard/series/football/upcomingseriesfb",
      },
      {
        title: "Active Series",
        path: "/dashboard/series/football/activeseriesfb",
      },
      {
        title: "Contests",
        path: "/dashboard/series/football/contestfb",
      },
    ],
  },
  {
    title: "Banner Management",
    path: "/dashboard/banner-management",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Reports",
    path: "/dashboard/report_management",
    icon: getIcon("mdi:cog"),
    children: [
      {
        title: "Cricket Status",
        path: "/dashboard/status-management/cricket",
        icon: getIcon("mdi:cog"),
      },
      {
        title: "Football Status",
        path: "/dashboard/status-management/football",
        icon: getIcon("mdi:cog"),
      },

      {
        title: "Transaction History",
        path: "/dashboard/transactions",
        icon: getIcon("ph:currency-circle-dollar-fill"),
      },
      {
        title: "Report Management",
        path: "/dashboard/report_management",
        icon: getIcon("mdi:cog"),
      },
    ],
  },
  {
    title: "Theme Customization",
    path: "/dashboard/customization",
    icon: getIcon("mingcute:user-setting-fill"),
  },

   {
    title: "Settings",
    path: "/dashboard/settings",
    icon: getIcon("mdi:cog"),
  },
];

navConfig["3"] = [
  {
    title: "dashboard",
    path: "/dashboard/app",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "User Management",
    path: "/dashboard/user",
    icon: getIcon("eva:people-fill"),
    children: [
      // {
      //     title: "List",
      //     path: "/dashboard/user/list",
      // },

      {
        title: "Active User",
        path: "/dashboard/user/list?type=1",
      },
      {
        title: "KYC Verification pending",
        path: "/dashboard/user/list?type=2",
      },
    ],
  },
  {
    title: "Sub-Admin Management",
    path: "/dashboard/sub-admin",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "List",
        path: "/dashboard/sub-admin/list",
      },
      {
        title: "Create",
        path: "/dashboard/sub-admin/create",
      },
    ],
  },
  {
    title: "Cricket Matches",
    path: "/dashboard/cricket",
    icon: getIcon("material-symbols:sports-cricket"),
    children: [
      {
        title: "Upcoming Matches",
        path: "/dashboard/cricket/upcoming_match_list",
      },
      {
        title: "Active Matchs",
        path: "/dashboard/cricket/active_match_list",
      },
      {
        title: "Contests",
        path: "/dashboard/cricket/contest_list",
      },
      // {
      //   title: 'Assign Contest',
      //   path: '/dashboard/cricket/assign_contest_list'
      // },
    ],
  },
  {
    title: "Football Matches",
    path: "/dashboard/football",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Upcoming Matches",
        path: "/dashboard/football/upcoming_football_list",
      },
      {
        title: "Active Matchs",
        path: "/dashboard/football/active_football_list",
      },
      {
        title: "Contests",
        path: "/dashboard/football/contest_football_list",
      },
      // {
      //   title: 'Assign Contest',
      //   path: '/dashboard/cricket/assign_contest_list'
      // },
    ],
  },
  {
    title: "Cricket Series",
    path: "/dashboard/series/cricket",
    icon: getIcon("material-symbols:sports-cricket"),
    children: [
      {
        title: "Upcoming Series",
        path: "/dashboard/series/cricket/upcomingseries",
      },
      {
        title: "Active Series",
        path: "/dashboard/series/cricket/activeseries",
      },
      {
        title: "Contests",
        path: "/dashboard/series/cricket/contest",
      },
    ],
  },
  {
    title: "Football Series",
    path: "/dashboard/series/football",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Upcoming Series",
        path: "/dashboard/series/football/upcomingseriesfb",
      },
      {
        title: "Active Series",
        path: "/dashboard/series/football/activeseriesfb",
      },
      {
        title: "Contests",
        path: "/dashboard/series/football/contestfb",
      },
    ],
  },
  {
    title: "Cron Activity",
    path: "/dashboard/football",
    icon: getIcon("ion:football"),
    children: [
      {
        title: "Cricket Match",
        path: "/dashboard/cricket_matches",
      },
      {
        title: "Football Match",
        path: "/dashboard/football_matches",
      }]
    },
  {
    title: "Points Management",
    path: "/dashboard/points-management",
    icon: getIcon("ph:coin-vertical-fill"),
    children: [
      {
        title: "Cricket Points",
        path: "/dashboard/points-management/cricket",
      },
      {
        title: "Football Points",
        path: "/dashboard/points-management/football",
      },
    ],
  },
  {
    title: "Withdraw Request",
    path: "/dashboard/withdraw-requests",
    icon: getIcon("ph:currency-circle-dollar-fill"),
  },
  {
    title: "Wallet Management",
    path: "/dashboard/wallet",
    icon: getIcon("material-symbols:account-balance-wallet"),
  },
  {
    title: "Notification",
    path: "/dashboard/notification/list",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "List",
        path: "/dashboard/notification/list",
      },
      {
        title: "Send Message",
        path: "/dashboard/notification/create",
      },
    ],
  },
  {
    title: "CMS Management",
    path: "/dashboard/cms-management",
    icon: getIcon("mdi:note"),
    children: [
      {
        title: "Category",
        path: "/dashboard/cms/category",
      },
      {
        title: "FAQs",
        path: "/dashboard/cms/faqs",
      },
      {
        title: "Other CMS",
        path: "/dashboard/cms/others",
      },
    ],
  },

  {
    title: "Teams Manager",
    path: "/dashboard/teams-manager",
    icon: getIcon("mdi:account-group"),
    children: [
      {
        title: "Cricket",
        path: "/dashboard/teams-manager/cricket",
      },
      {
        title: "Football",
        path: "/dashboard/teams-manager/football",
      },
    ],
  },

  {
    title: "Banner Management",
    path: "/dashboard/banner-management",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "State Management",
    path: "/dashboard/state-management",
    icon: getIcon("mdi:flag"),
  },
  {
    title: "TDS Manager",
    path: "/dashboard/tds-manager",
    icon: getIcon("mdi:flag"),
  },
  {
    title: "Player Manager",
    path: "/dashboard/player-manager",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "Cricket",
        path: "/dashboard/player-manager/cricket",
      },
      {
        title: "Football",
        path: "/dashboard/player-manager/football",
      },
    ],
  },
  {
    title: "Series Manager",
    path: "/dashboard/series-manager",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "Cricket",
        path: "/dashboard/series-manager/cricket",
      },
      {
        title: "Football",
        path: "/dashboard/series-manager/football",
      },
    ],
  },

  {
    title: "Player Accumulator",
    path: "/dashboard/player-accumulator",
    icon: getIcon("eva:people-fill"),
    children: [
      {
        title: "Cricket Player",
        path: "/dashboard/player-accumulator/cricket",
      },
      {
        title: "Football Player",
        path: "/dashboard/player-accumulator/football",
      },
    ],
  }, 

  // yogesh code for get all contact us
  {
    title: "Contact Us List",
    path: "/dashboard/contact_us_list",
    icon: getIcon("eva:people-fill"),
  },
  {
    title: "Reports",
    path: "/dashboard/report_management",
    icon: getIcon("mdi:cog"),
    children: [
      {
        title: "Cricket Status",
        path: "/dashboard/status-management/cricket",
        icon: getIcon("mdi:cog"),
      },
      {
        title: "Football Status",
        path: "/dashboard/status-management/football",
        icon: getIcon("mdi:cog"),
      },

      {
        title: "Transaction History",
        path: "/dashboard/transactions",
        icon: getIcon("ph:currency-circle-dollar-fill"),
      },
      {
        title: "Report Management",
        path: "/dashboard/report_management",
        icon: getIcon("mdi:cog"),
      },
    ],
  },

  {
    title: "Settings",
    path: "/dashboard/settings",
    icon: getIcon("mdi:cog"),
  },
];

export default navConfig;
